import React from 'react';

// Design-system Badge (REZ-1309). Renders the rr-badge classes from src/theme/components.css.
// tone: neutral | primary | success | danger | warning | info. The text is *-text on *-soft,
// which passes 4.5:1 in both themes. Always include a word: colour never carries meaning alone.
const Badge = ({ tone = 'neutral', pill = false, dot = false, className = '', children, ...rest }) => {
  const classes = ['rr-badge', tone !== 'neutral' ? `rr-badge--${tone}` : null, pill ? 'rr-badge--pill' : null, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...rest}>
      {dot ? <span className="rr-badge__dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
};

export default Badge;
